<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>财务系统</el-breadcrumb-item>
            <el-breadcrumb-item>透支列表</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row style="margin-bottom:10px">
        <el-col :span="6">
          <el-input size="small" clearable v-model="searchName" placeholder="请输入公司名称或账户名称">
            <el-button slot="append" icon="el-icon-search" @click="SearchByName"></el-button>
          </el-input>
        </el-col>
        <el-col :span="2">
          <el-button type="primary" size="small" @click="Refresh" plain>刷新</el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-table :data="overDraftList" style="width: 100%" v-loading="loading" size="small">
            <el-table-column prop="Uid" label="账户ID"></el-table-column>
            <el-table-column prop="Account_name" label="账户名称"></el-table-column>
            <el-table-column prop="Company_name" label="公司名称"></el-table-column>
            <el-table-column prop="OverdraftMoney" label="未还透支金额"></el-table-column>
            <el-table-column label="操作" fixed="right" width="200">
              <template slot-scope="scope">
                <el-button type="text" @click="GetChildrenOverdrafts(scope.row)" size="small">透支详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row style="margin-top:10px">
        <el-col :span="24">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
            style="float:right"
          ></el-pagination>
        </el-col>
      </el-row>
    </el-card>
    <el-dialog width="50%" :title="dialagTitle" :visible.sync="dialogTableVisible">
      <el-table
        :data="childrenOverdrafts"
        show-summary
        style="width: 100%"
        v-loading="loading"
        size="small"
      >
        <el-table-column prop="Uid" label="账户ID"></el-table-column>
        <el-table-column prop="Account_name" label="账户名称"></el-table-column>
        <el-table-column prop="Company_name" label="公司名称"></el-table-column>
        <el-table-column prop="OverdraftTime" label="透支时间"></el-table-column>
        <el-table-column prop="OverdraftMoney" label="透支金额"></el-table-column>
        <el-table-column prop="RepaymentStatus" :formatter="isReturn" label="是否还款"></el-table-column>
        <el-table-column prop="Remark" label="备注"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetOverDraftPageList,
  GetOverdraftByAccountID
} from "../../until/ZeusApiSDK/Logic/FinancialLogic";
import { GetCurrentUserInfo,GetCurrentUserRole } from "../../until/ZeusApiSDK/Logic/HomeLogic";
export default {
  data() {
    return {
      searchName: "",
      overDraftList: [],
      pageSizes: [10, 20, 50, 100, 200],
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      loading: true,
      childrenOverdrafts: [],
      dialogTableVisible: false,
      dialagTitle: ""
    };
  },
  created() {
    this.GetOverDraftPageList();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetOverDraftPageList();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetOverDraftPageList();
    },
    SearchByName: function() {
      this.pageIndex = 1;
      this.GetOverDraftPageList();
    },
    Refresh:function(){
      this.GetOverDraftPageList();
    },
    GetOverDraftPageList:async function() {
      this.loading = true;
      var userinfo = GetCurrentUserInfo();
      var currentUserRole = await GetCurrentUserRole();
      var isAll = "0";
      if (currentUserRole.Key == "admin") {
        isAll = "all";
      }
      GetOverDraftPageList(
        userinfo.UserCode,
        isAll,
        this.pageIndex,
        this.pageSize,
        this.searchName
      ).then(pageRes => {
        this.overDraftList = pageRes.DataList;
        this.totalCount = pageRes.TotalCount;
        this.loading = false;
      });
    },
    GetChildrenOverdrafts: function(row) {
      this.dialagTitle = row.Account_name + "-透支详情";
      GetOverdraftByAccountID(row.Uid).then(res => {
        this.childrenOverdrafts = res;
        this.dialogTableVisible = true;
      });
    },
    isReturn(row, column, cellValue, index) {
      if (cellValue == 0) {
        return "未还款";
      } else if (cellValue == 1) {
        return "已还款";
      }
    }
  }
};
</script>